// src/theme.ts
export interface Theme {
  breakpoints: {
    mobile: string;
    tablet: string;
    laptop: string;
    desktop: string;
  };
  colors: {
    primary: string;
    blue: string;
    red: string;
    green: string;
    gray: string;
    gray100: string;
    gray150: string;
    gray200: string;
    gray400: string;
    gray300: string;
    darkGray: string;
    yellow: string;
    opacity_yellow: string;
    darkBg: string;
    darkerBg: string;
    white: string;
    black: string;
    purple: string;
    orange: string;
  };
  fonts: {
    body: string;
    main: string;
  };
  margins: {
    xsmall: string;
    small: string;
    medium: string;
    mediumL: string;
    large: string;
    xl: string;
    "2xl": string;
  };
}

export const screenSize = {
  mobile: "480px", // Mobile max width (mobile first)
  tablet: "768px",
  laptop: "1024px",
  desktop: "1440px",
  desktopXL: "2560px",
};

export const device = {
  mobile: `(max-width: ${screenSize.mobile})`, // For screens <= 480px
  tablet: `(min-width: ${screenSize.mobile}) and (max-width: ${screenSize.tablet})`, // For screens between 480px and 768px
  laptop: `(min-width: ${screenSize.tablet}) and (max-width: ${screenSize.laptop})`, // For screens between 768px and 1024px
  desktop: `(min-width: ${screenSize.laptop}) and (max-width: ${screenSize.desktop})`, // For screens between 1024px and 1440px
  desktopXL: `(min-width: ${screenSize.desktop})`, // For screens >= 1440px
};

export const theme: Theme = {
  breakpoints: {
    mobile: screenSize.mobile,
    tablet: screenSize.tablet,
    laptop: screenSize.laptop,
    desktop: screenSize.desktop,
  },
  margins: {
    xsmall: "4px",
    small: "8px",
    medium: "16px",
    mediumL: "24px",
    large: "32px",
    xl: "40px",
    "2xl": "64px",
  },
  colors: {
    primary: "#FFF057",
    blue: "#2D70E2",
    red: "#FF4116",
    green: "#00B86B",
    gray: "#979794",
    gray100: "rgb(180, 180, 180)",
    gray150: "#A6A6A6",
    gray200: "#6E6E6E",
    gray400: "#2D2D2D",
    gray300: "#2A2A2A",
    darkGray: "#222222",
    yellow: "#FFF057",
    opacity_yellow: "rgba(255, 240, 87, 0.5)",
    darkBg: "#161616",
    darkerBg: "#111111",
    white: "#FFFFFF",

    black: "#000000",
    purple: "#9747FF",
    orange: "#DE6920",
  },
  fonts: {
    body: '"Kern Standard", "Roboto", Arial, sans-serif',
    main: '"Kern Standard", "Roboto", Arial, sans-serif',
  },
};
